function getPosition(el) {
    var xPos = 0;
    var yPos = 0;

    while (el) {
        if (el.tagName == "BODY") {
            // deal with browser quirks with body/window/document and page scroll
            var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
            var yScroll = el.scrollTop || document.documentElement.scrollTop;

            xPos += (el.offsetLeft - xScroll + el.clientLeft);
            yPos += (el.offsetTop - yScroll + el.clientTop);
        } else {
            // for all other non-BODY elements
            xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft);
            yPos += (el.offsetTop - el.scrollTop + el.clientTop);
        }

        el = el.offsetParent;
    }
    return {
        x: xPos,
        y: yPos
    };
}

// deal with the page getting resized or scrolled
window.addEventListener("scroll", updatePosition, false);
window.addEventListener("resize", updatePosition, false);

function updatePosition() {
    // add your code to update the position when your browser
    // is resized or scrolled
}

window.addEventListener('click', function(e) {
    tooltipPosition();
});

function tooltipPosition() {
    g_dev = true;
    g_windowWidth = document.documentElement.clientWidth;

    const elems = document.querySelectorAll('.tooltip');
    const $elems = [].slice.call(elems);

    $elems.map((element) => {
        var elementParent = getClosest(element,'.tooltip-trigger');
        var elementParentRect = elementParent.getBoundingClientRect();

        var elementHeight = element.offsetHeight;
        var elementWidth = element.offsetWidth;
        var elementRect = element.getBoundingClientRect();

        if ((elementParentRect.left + elementWidth) > g_windowWidth) {
            if (!element.classList.contains('right')) {
                element.classList.add('right');
            }
        } else {
            element.classList.remove('right');
        }

        if(g_dev === true) {
            console.log(elementParent.left);
            // console.log(elementRect.right);
            // console.log(elementParent.offsetWidth);
            // console.log(elementWidth);
            // console.log(g_windowWidth);
            // console.log(element.getBoundingClientRect());
        }
    });
}

window.addEventListener('resize', function(event){
    updateTooltipPosition();
});

function updateTooltipPosition() {
    g_dev = true;
    g_windowWidth = document.documentElement.clientWidth;

    const elems = document.querySelectorAll('.tooltip');
    const $elems = [].slice.call(elems);

    $elems.map((element) => {
        var elementParent = getClosest(element,'.tooltip-trigger');
        var elementParentRect = elementParent.getBoundingClientRect();

        var elementHeight = element.offsetHeight;
        var elementWidth = element.offsetWidth;
        var elementRect = element.getBoundingClientRect();

        if ((elementParentRect.left + elementWidth) > g_windowWidth) {
            if (!element.classList.contains('right')) {
                element.classList.add('right');
            }
        } else {
            element.classList.remove('right');
        }

        if(g_dev === true) {
            // console.log(elementParentRect);
            // console.log(elementRect.right);
            // console.log(g_windowWidth);
            // console.log(element.getBoundingClientRect());
        }
    });
}
